import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';

const SelectChairsContainer = styled.div`
  min-height: 90vh;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 130px 0 100px;

  * {
    font-family: 'Geist', sans-serif !important;
  }

  .container {
    max-width: 700px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 4rem;
    align-items: center;
  }

  .top-section {
    position: relative;
    height: 300px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .main-title {
    color: #1e3a8a;
    text-align: center;
    font-size: 60px;
    font-weight: 700;
    line-height: 1.1;
    margin: 0 0 1.5rem 0;
    text-transform: uppercase;
    width: 605px;
    height: 100%;
  }

  .chair-graphic {
    position: relative;
    background: url('https://comunidadmde.s3.us-east-1.amazonaws.com/resources/legado/silla_desvanecida_azul.png')
      no-repeat center;
    background-size: contain;
    width: 400px;
    height: 375px;
    margin: 0 auto;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    @media (max-width: ${screenSizes.tablet}) {
      width: 300px;
    }
  }

  .selector-container {
    position: absolute;
    left: 50%;
    bottom: 10px;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: 1.5rem;
    z-index: 2;
  }

  .circle-btn {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #1e3a8a;
    color: white;
    font-size: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    transition: background 0.2s;
    box-shadow: 0 2px 8px rgba(30, 58, 138, 0.08);
    user-select: none;
  }
  .circle-btn:active {
    background: #2746b3;
  }

  .chair-count {
    font-size: 2.5rem;
    color: #1e3a8a;
    font-weight: 700;
    min-width: 40px;
    text-align: center;
  }

  .go-back-btn {
    align-self: flex-start;
    margin-left: 0;
    margin-bottom: 1rem;
    background: transparent;
    color: #1e3a8a;
    border: 1px solid #1e3a8a;
    border-radius: 16px;
    font-size: 0.85rem;
    font-weight: 500;
    padding: 4px 14px;
    cursor: pointer;
    z-index: 200;
  }
  .go-back-btn:active {
    background: #e6eaff;
    color: #2746b3;
  }

  @media (max-width: 1050px) {
    padding: 0 30px 0 30px;
    .main-title {
      font-size: 2.5rem;
      width: 100%;
    }
  }
  @media (max-width: ${screenSizes.tablet}) {
    .main-title {
      font-size: 2rem;
      width: 100%;
    }
    .selector-container {
      gap: 1rem;
      bottom: 0px;
    }
  }

  .donate-btn {
    background: #1e3a8a;
    color: white;
    font-size: 1.5rem;
    font-weight: 600;
    padding: 18px 60px;
    border: none;
    border-radius: 32px;
    box-shadow: 0 2px 16px rgba(30, 58, 138, 0.12);
    cursor: pointer;
    z-index: 100;
  }
  .donate-btn:active {
    background: #2746b3;
  }
`;
export const sillaValue = 2500000;

const LegadoSelectChairs = ({ category, inputs, setInputs, setCategory }) => {
  const handleDecrement = () => {
    if (inputs.chairs > 1) {
      setInputs({ ...inputs, chairs: inputs.chairs - 1 });
    }
  };
  const handleIncrement = () => {
    setInputs({ ...inputs, chairs: inputs.chairs + 1 });
  };

  const handleContinue = () => {
    if (category === 'chairsToCommit') {
      setInputs({ ...inputs, chairsToCommit: inputs.chairs });
      setCategory('donateSillaInParts');
    } else {
      setInputs({ ...inputs, value: sillaValue * inputs.chairs });
      setCategory('donateChairs');
    }
  };

  const handleBack = () => {
    let backTo = '';
    backTo = 'general';

    setCategory(backTo);
    setInputs({
      chairsToCommit: 0,
      valueToCommit: 0,
      identification: inputs.identification,
      phone: inputs.phone,
      chairs: 1,
    });
  };

  return (
    <SelectChairsContainer>
      <div className="container">
        <button className="go-back-btn" onClick={handleBack}>
          Volver
        </button>
        <div className="top-section">
          <h1 className="main-title">
            {category === 'chairsToCommit'
              ? '¿Con cuántas sillas te quieres comprometer?'
              : '¿Cuántas sillas quieres donar?'}
          </h1>
          <div className="chair-graphic">
            <div className="selector-container">
              <button className="circle-btn" onClick={handleDecrement} aria-label="Restar silla">
                -
              </button>
              <span className="chair-count">{inputs.chairs}</span>
              <button className="circle-btn" onClick={handleIncrement} aria-label="Sumar silla">
                +
              </button>
            </div>
          </div>
        </div>
        <button className="donate-btn" onClick={handleContinue}>
          Continuar
        </button>
      </div>
    </SelectChairsContainer>
  );
};

export default LegadoSelectChairs;
